var OSS = require('ali-oss');
export default {
  uploadImg(filePath, file) {
    const client = new OSS({
      region: 'oss-cn-beijing',
      endPoint: 'oss-cn-beijing.aliyuncs.com',
      secure: true,
      accessKeyId: 'LTAIOIGjvl2iU9vX',
      accessKeySecret: '202F429QlafX3xdqwjbHUK948qmMs1',
      bucket: 'hdsys',
    });
    let len = 8;
    var $chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';
    var maxPos = $chars.length;
    var pwd = '';
    for (let i = 0; i < len; i++) {
      pwd += $chars.charAt(Math.floor(Math.random() * maxPos)); // 生成8位随机字符
    }
    // let type = '.'+blob.type.substring(6);
    var fileName = `${Date.parse(new Date())}` + pwd + file.name; // 文件名称（时间戳+随机字符+后缀）
    const result = client.put(filePath + fileName, file.raw || file);
    return result;
    // return new Promise((resolve, reject) => {
    //     client.put(file.name, file).then(function (result) {
    //         resolve(result.url);
    //     }).catch(function (err) {
    //         reject(err);
    //     });
    // });
  },
};
